import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
export var getEstimatedViewportType = function() {
    return getGlobalProperty("estimatedViewportType", {
        width: 1280,
        height: 768,
        type: "desktop"
    });
};
